import React, { Component, PropTypes } from 'react';
import {
    Grid,
    TextField,
    Button,
    Select,
    MenuItem,
    Checkbox,
    FormGroup,
    FormControlLabel,
    Radio,
} from '@material-ui/core';
import NewPatientPhoto from './NewPatientPhoto';
import style from './NewPatientPhotos.module.css';
import DragAndDrop from '../Photos/DragAndDrop';
import { Animated } from 'react-animated-css';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import { getWebAbsPath } from '../../../util/path';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { connect } from 'react-redux';
import { withLang } from '../../../util/lang';
import axios from '../../../axios-default';
import ModalLoader from '../../ModalLoader';
import RadioGroup from '@material-ui/core/RadioGroup';

import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
class Defect extends Component {
    constructor(props) {
        super(props);
    }

    fileupload(file, stateType) {
        let ClassThis = this;
        let fileName = file.name;
        ClassThis.props.handleDefectData(file, stateType, fileName);
        // let baseFile = this.fileToBase64(file).then((data) => {
        //   ClassThis.props.handleTreatmentData(data, stateType, fileName)
        // })
    }

    onFileChange = (event, stateType) => {
        let compo = this;
        let fileName = event.target.files[0].name;
        compo.props.handleDefectData(event.target.files[0], stateType, fileName);
        // let baseFile = compo.fileToBase64(event.target.files[0]).then((data) => {
        //   compo.props.handleTreatmentData(data, stateType, fileName)
        // })
    };

    handleDrop = (uploadedFile, stateType) => {
        this.fileupload(uploadedFile, stateType);
    };

    removefile(stateType) {
        this.props.handleDefectData(null, stateType, '');
        //this.props.handleDataPhoto("")
    }

    render() {
        return (
            <Animated animationIn="fadeIn" isVisible={true}>
                <FormControl style={{ width: '100%' }}>
                    <FormLabel id="demo-radio-buttons-group-label">Upload Defect Photos</FormLabel>
                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="moderately"
                        name="radio-buttons-group"
                        onChange={(e) => this.props.handleSelect(e.target.value)}
                    >
                        {' '}
                        <Grid item xs={12}>
                            <FormControlLabel value="moderately" control={<Radio />} label="Moderate Distortion" />
                            <FormControlLabel value="severely" control={<Radio />} label="Severe Distortion" />
                        </Grid>
                        <Grid item xs={12}></Grid>
                        <Grid container spacing={1} className={style.twoColumnImage}>
                            {this.props.defect.severely_or_moderately === 'severely' && (
                                <>
                                    <Grid item xs={12} sm={3}>
                                        {this.props.defect.spic1 === null ? (
                                            <DragAndDrop
                                                handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'spic1')}
                                            >
                                                <div className={style.imageUploadArea}>
                                                    <span>{this.get('defect.dragAndDrop')}</span>

                                                    <div className={style.uploadBtnWrapper}>
                                                        <button className={style.uploadBtn}>+</button>
                                                        <input
                                                            type="file"
                                                            onChange={(e) => this.onFileChange(e, 'spic1')}
                                                            name="patientImage"
                                                            id="patientImage"
                                                        />
                                                    </div>
                                                </div>
                                            </DragAndDrop>
                                        ) : (
                                            <DragAndDrop
                                                handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'spic1')}
                                            >
                                                <div class={style.imageUploadArea}>
                                                    <button
                                                        className={style.remove}
                                                        onClick={() => this.removefile('spic1')}
                                                    >
                                                        <DeleteOutlinedIcon />
                                                    </button>
                                                    <img src={URL.createObjectURL(this.props.defect.spic1)} />
                                                </div>
                                            </DragAndDrop>
                                        )}
                                        <p style={{ textAlign: 'center', color: 'rgba(0,0,0,0.3)' }}></p>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        {this.props.defect.spic2 === null ? (
                                            <DragAndDrop
                                                handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'spic2')}
                                            >
                                                <div className={style.imageUploadArea}>
                                                    <span>{this.get('treatmentPlan.dragAndDrop')}</span>
                                                    <div className={style.uploadBtnWrapper}>
                                                        <button className={style.uploadBtn}>+</button>
                                                        <input
                                                            type="file"
                                                            onChange={(e) => this.onFileChange(e, 'spic2')}
                                                            name="patientImage"
                                                            id="patientImage"
                                                        />
                                                    </div>
                                                </div>
                                            </DragAndDrop>
                                        ) : (
                                            <DragAndDrop
                                                handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'spic2')}
                                            >
                                                <div class={style.imageUploadArea}>
                                                    <img src={URL.createObjectURL(this.props.defect.spic2)} />
                                                    <button
                                                        className={style.remove}
                                                        onClick={() => this.removefile('spic2')}
                                                    >
                                                        <DeleteOutlinedIcon />
                                                    </button>
                                                </div>
                                            </DragAndDrop>
                                        )}
                                        <p style={{ textAlign: 'center', color: 'rgba(0,0,0,0.3)' }}></p>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        {this.props.defect.spic3 === null ? (
                                            <DragAndDrop
                                                handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'spic3')}
                                            >
                                                <div className={style.imageUploadArea}>
                                                    <span>{this.get('treatmentPlan.dragAndDrop')}</span>
                                                    <div className={style.uploadBtnWrapper}>
                                                        <button className={style.uploadBtn}>+</button>
                                                        <input
                                                            type="file"
                                                            onChange={(e) => this.onFileChange(e, 'spic3')}
                                                            name="patientImage"
                                                            id="patientImage"
                                                        />
                                                    </div>
                                                </div>
                                            </DragAndDrop>
                                        ) : (
                                            <DragAndDrop
                                                handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'spic3')}
                                            >
                                                <div class={style.imageUploadArea}>
                                                    <button
                                                        className={style.remove}
                                                        onClick={() => this.removefile('spic3')}
                                                    >
                                                        <DeleteOutlinedIcon />
                                                    </button>
                                                    <img src={URL.createObjectURL(this.props.defect.spic3)} />
                                                </div>
                                            </DragAndDrop>
                                        )}
                                        <p style={{ textAlign: 'center', color: 'rgba(0,0,0,0.3)' }}></p>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        {this.props.defect.spic4 === null ? (
                                            <DragAndDrop
                                                handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'spic4')}
                                            >
                                                <div className={style.imageUploadArea}>
                                                    <span>{this.get('treatmentPlan.dragAndDrop')}</span>
                                                    <div className={style.uploadBtnWrapper}>
                                                        <button className={style.uploadBtn}>+</button>
                                                        <input
                                                            type="file"
                                                            onChange={(e) => this.onFileChange(e, 'spic4')}
                                                            name="patientImage"
                                                            id="patientImage"
                                                        />
                                                    </div>
                                                </div>
                                            </DragAndDrop>
                                        ) : (
                                            <DragAndDrop
                                                handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'spic4')}
                                            >
                                                <div class={style.imageUploadArea}>
                                                    <button
                                                        className={style.remove}
                                                        onClick={() => this.removefile('spic4')}
                                                    >
                                                        <DeleteOutlinedIcon />
                                                    </button>
                                                    <img src={URL.createObjectURL(this.props.defect.spic4)} />
                                                </div>
                                            </DragAndDrop>
                                        )}
                                        <p style={{ textAlign: 'center', color: 'rgba(0,0,0,0.3)' }}></p>
                                    </Grid>
                                </>
                            )}
                            {this.props.defect.severely_or_moderately === 'moderately' && (
                                <>
                                    <Grid item xs={12} sm={3}>
                                        {this.props.defect.mpic1 === null ? (
                                            <DragAndDrop
                                                handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'mpic1')}
                                            >
                                                <div className={style.imageUploadArea}>
                                                    <span>{this.get('treatmentPlan.dragAndDrop')}</span>
                                                    <div className={style.uploadBtnWrapper}>
                                                        <button className={style.uploadBtn}>+</button>
                                                        <input
                                                            type="file"
                                                            onChange={(e) => this.onFileChange(e, 'mpic1')}
                                                            name="patientImage"
                                                            id="patientImage"
                                                        />
                                                    </div>
                                                </div>
                                            </DragAndDrop>
                                        ) : (
                                            <DragAndDrop
                                                handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'mpic1')}
                                            >
                                                <div class={style.imageUploadArea}>
                                                    <button
                                                        className={style.remove}
                                                        onClick={() => this.removefile('mpic1')}
                                                    >
                                                        <DeleteOutlinedIcon />
                                                    </button>
                                                    <img src={URL.createObjectURL(this.props.defect.mpic1)} />
                                                </div>
                                            </DragAndDrop>
                                        )}
                                        <p style={{ textAlign: 'center', color: 'rgba(0,0,0,0.3)' }}></p>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        {this.props.defect.mpic2 === null ? (
                                            <DragAndDrop
                                                handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'mpic2')}
                                            >
                                                <div className={style.imageUploadArea}>
                                                    <span>{this.get('treatmentPlan.dragAndDrop')}</span>
                                                    <div className={style.uploadBtnWrapper}>
                                                        <button className={style.uploadBtn}>+</button>
                                                        <input
                                                            type="file"
                                                            onChange={(e) => this.onFileChange(e, 'mpic2')}
                                                            name="patientImage"
                                                            id="patientImage"
                                                        />
                                                    </div>
                                                </div>
                                            </DragAndDrop>
                                        ) : (
                                            <DragAndDrop
                                                handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'mpic2')}
                                            >
                                                <div class={style.imageUploadArea}>
                                                    <button
                                                        className={style.remove}
                                                        onClick={() => this.removefile('mpic2')}
                                                    >
                                                        <DeleteOutlinedIcon />
                                                    </button>
                                                    <img src={URL.createObjectURL(this.props.defect.mpic2)} />
                                                </div>
                                            </DragAndDrop>
                                        )}
                                        <p style={{ textAlign: 'center', color: 'rgba(0,0,0,0.3)' }}></p>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        {this.props.defect.mpic3 === null ? (
                                            <DragAndDrop
                                                handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'mpic3')}
                                            >
                                                <div className={style.imageUploadArea}>
                                                    <span>{this.get('treatmentPlan.dragAndDrop')}</span>
                                                    <div className={style.uploadBtnWrapper}>
                                                        <button className={style.uploadBtn}>+</button>
                                                        <input
                                                            type="file"
                                                            onChange={(e) => this.onFileChange(e, 'mpic3')}
                                                            name="patientImage"
                                                            id="patientImage"
                                                        />
                                                    </div>
                                                </div>
                                            </DragAndDrop>
                                        ) : (
                                            <DragAndDrop
                                                handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'mpic3')}
                                            >
                                                <div class={style.imageUploadArea}>
                                                    <button
                                                        className={style.remove}
                                                        onClick={() => this.removefile('mpic3')}
                                                    >
                                                        <DeleteOutlinedIcon />
                                                    </button>
                                                    <img src={URL.createObjectURL(this.props.defect.mpic3)} />
                                                </div>
                                            </DragAndDrop>
                                        )}
                                        <p style={{ textAlign: 'center', color: 'rgba(0,0,0,0.3)' }}></p>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        {this.props.defect.mpic4 === null ? (
                                            <DragAndDrop
                                                handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'mpic4')}
                                            >
                                                <div className={style.imageUploadArea}>
                                                    <span>{this.get('treatmentPlan.dragAndDrop')}</span>
                                                    <div className={style.uploadBtnWrapper}>
                                                        <button className={style.uploadBtn}>+</button>
                                                        <input
                                                            type="file"
                                                            onChange={(e) => this.onFileChange(e, 'mpic4')}
                                                            name="patientImage"
                                                            id="patientImage"
                                                        />
                                                    </div>
                                                </div>
                                            </DragAndDrop>
                                        ) : (
                                            <DragAndDrop
                                                handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'mpic4')}
                                            >
                                                <div class={style.imageUploadArea}>
                                                    <button
                                                        className={style.remove}
                                                        onClick={() => this.removefile('mpic4')}
                                                    >
                                                        <DeleteOutlinedIcon />
                                                    </button>
                                                    <img src={URL.createObjectURL(this.props.defect.mpic4)} />
                                                </div>
                                            </DragAndDrop>
                                        )}
                                        <p style={{ textAlign: 'center', color: 'rgba(0,0,0,0.3)' }}></p>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    </RadioGroup>
                </FormControl>
            </Animated>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        lang: store.lang,
    };
};

//export default connect(mapStateToProps)(withLang(TreatmentPlan, 'PatientInfo'));
export default connect(mapStateToProps)(withLang(Defect, 'Defect'));
